var exports = {
  "container": "xaee3c4fa--c6eddf--container",
  "text-block": "xaee3c4fa--c6eddf--text-block",
  "tablet": "xaee3c4fa--c6eddf--tablet",
  "phone": "xaee3c4fa--c6eddf--phone",
};

module.exports = exports;
